export {IDisplayObjectAdapter}			from "./adapters/IDisplayObjectAdapter";
export {IMovieClipAdapter}				from "./adapters/IMovieClipAdapter";